/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TeamScheduleDisplayQueryVariables = {|
  teamId: string,
  seasonID?: ?string,
|};
export type TeamScheduleDisplayQueryResponse = {|
  +nflGameResultsForTeam: ?$ReadOnlyArray<?{|
    +week: ?{|
      +week: number
    |},
    +team: ?{|
      +city: ?string,
      +logoSrc: ?string,
    |},
    +opp: ?{|
      +city: ?string,
      +logoSrc: ?string,
    |},
    +teamScore: ?number,
    +oppScore: ?number,
    +home: ?boolean,
  |}>
|};
export type TeamScheduleDisplayQuery = {|
  variables: TeamScheduleDisplayQueryVariables,
  response: TeamScheduleDisplayQueryResponse,
|};
*/


/*
query TeamScheduleDisplayQuery(
  $teamId: ID!
  $seasonID: ID
) {
  nflGameResultsForTeam(teamId: $teamId, seasonId: $seasonID) {
    week {
      week
      id
    }
    team {
      city
      logoSrc
      id
    }
    opp {
      city
      logoSrc
      id
    }
    teamScore
    oppScore
    home
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "week",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoSrc",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamScore",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oppScore",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "home",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamGameResultType",
        "kind": "LinkedField",
        "name": "nflGameResultsForTeam",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatWeekType",
            "kind": "LinkedField",
            "name": "week",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamScheduleDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "NFLTeamGameResultType",
        "kind": "LinkedField",
        "name": "nflGameResultsForTeam",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatWeekType",
            "kind": "LinkedField",
            "name": "week",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f389ed748b5e6012f229c96431323311",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleDisplayQuery",
    "operationKind": "query",
    "text": "query TeamScheduleDisplayQuery(\n  $teamId: ID!\n  $seasonID: ID\n) {\n  nflGameResultsForTeam(teamId: $teamId, seasonId: $seasonID) {\n    week {\n      week\n      id\n    }\n    team {\n      city\n      logoSrc\n      id\n    }\n    opp {\n      city\n      logoSrc\n      id\n    }\n    teamScore\n    oppScore\n    home\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eb7e905ab5db25932b8564b15c00247c';

module.exports = node;
